/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('../utils/logger')('splitio-metrics');
var tracker = require('../utils/timeTracker');

var _require = require('../utils/constants'),
    LOCALHOST_MODE = _require.LOCALHOST_MODE;

var repeat = require('../utils/fn/repeat');

var metricsService = require('../services/metrics');
var metricsTimesServiceRequest = require('../services/metrics/times');
var metricsCountersServiceRequest = require('../services/metrics/counters');
var metricsDTO = require('../services/metrics/dto');

var impressionsService = require('../services/impressions');
var impressionsBulkRequest = require('../services/impressions/bulk');
var impressionsDTO = require('../services/impressions/dto');

var _require2 = require('./Collectors'),
    SegmentChangesCollector = _require2.SegmentChangesCollector,
    SplitChangesCollector = _require2.SplitChangesCollector,
    MySegmentsCollector = _require2.MySegmentsCollector,
    SDKCollector = _require2.SDKCollector;

var MetricsFactory = function MetricsFactory(context) {
  var settings = context.get(context.constants.SETTINGS);
  var storage = context.get(context.constants.STORAGE);
  var isLocalhostMode = settings.mode === LOCALHOST_MODE;

  var pushMetrics = function pushMetrics() {
    if (isLocalhostMode || storage.metrics.isEmpty() && storage.count.isEmpty()) return _promise2.default.resolve();

    log.info('Pushing metrics');
    var latencyTrackerStop = tracker.start(tracker.TaskNames.METRICS_PUSH);

    // POST latencies
    var latenciesPromise = storage.metrics.isEmpty() ? null : metricsService(metricsTimesServiceRequest(settings, {
      body: (0, _stringify2.default)(metricsDTO.fromLatenciesCollector(storage.metrics))
    })).then(function () {
      return storage.metrics.clear();
    }).catch(function () {
      return storage.metrics.clear();
    });

    // POST counters
    var countersPromise = storage.count.isEmpty() ? null : metricsService(metricsCountersServiceRequest(settings, {
      body: (0, _stringify2.default)(metricsDTO.fromCountersCollector(storage.count))
    })).then(function () {
      return storage.count.clear();
    }).catch(function () {
      return storage.count.clear();
    });

    return _promise2.default.all([latenciesPromise, countersPromise]).then(function (resp) {
      // After both finishes, track the end and return the results
      latencyTrackerStop();
      return resp;
    });
  };

  var pushImpressions = function pushImpressions() {
    if (isLocalhostMode || storage.impressions.isEmpty()) return _promise2.default.resolve();

    log.info('Pushing ' + storage.impressions.queue.length + ' impressions');
    var latencyTrackerStop = tracker.start(tracker.TaskNames.IMPRESSIONS_PUSH);

    return impressionsService(impressionsBulkRequest(settings, {
      body: (0, _stringify2.default)(impressionsDTO.fromImpressionsCollector(storage.impressions, settings))
    })).then(function () {
      latencyTrackerStop();
      return storage.impressions.clear();
    }).catch(function () {
      return storage.impressions.clear();
    });
  };

  var stopImpressionsPublisher = false;
  var stopPerformancePublisher = false;

  return {
    start: function start() {
      stopImpressionsPublisher = repeat(function (schedulePublisher) {
        return pushImpressions().then(function () {
          return schedulePublisher();
        });
      }, settings.scheduler.impressionsRefreshRate);

      stopPerformancePublisher = repeat(function (schedulePublisher) {
        return pushMetrics().then(function () {
          return schedulePublisher();
        });
      }, settings.scheduler.metricsRefreshRate);
    },
    flush: function flush() {
      return pushImpressions();
    },
    stop: function stop() {
      stopImpressionsPublisher && stopImpressionsPublisher();
      stopPerformancePublisher && stopPerformancePublisher();
    },


    // Metrics collectors
    collectors: {
      segmentChanges: new SegmentChangesCollector(storage),
      splitChanges: new SplitChangesCollector(storage),
      mySegments: new MySegmentsCollector(storage),
      SDK: new SDKCollector(storage)
    }
  };
};

module.exports = MetricsFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/metrics/index.js
// module id = 691
// module chunks = 10